import apiClient from '../../services/apiClient';

const API_BASE = '/api/v1/notification';

export const notificationAPI = {
  // Notification Settings
  getNotificationSettings: () => 
    apiClient.get(`${API_BASE}/settings/`, { withAuth: true }),
    
  createNotificationSettings: (data) =>
    apiClient.post(`${API_BASE}/settings/`, data, { withAuth: true }),
    
  updateNotificationSettings: (id, data) =>
    apiClient.put(`${API_BASE}/settings/${id}/`, data, { withAuth: true }),
    
  getLevels: () =>
    apiClient.get(`/api/v1/level/list`, { withAuth: true }),
    
  getOrCreateSettings: (data) =>
    apiClient.post(`${API_BASE}/settings/get_or_create_settings/`, data, { withAuth: true }),

  // Notification History
  getNotificationHistory: (params = {}) =>
    apiClient.get(`${API_BASE}/history/`, { params, withAuth: true }),

  // SendOn API Settings
  getSendOnAPISettings: () =>
    apiClient.get(`${API_BASE}/api-settings/`, { withAuth: true }),
    
  updateAPIKey: (apiKey) =>
    apiClient.post(`${API_BASE}/api-settings/update_api_key/`, { api_key: apiKey }, { withAuth: true }),
    
  updateSendOnAPISettings: (data) =>
    apiClient.post(`${API_BASE}/api-settings/update_api_key/`, data, { withAuth: true }),
    
  testAPIKey: () =>
    apiClient.post(`${API_BASE}/api-settings/test_api_key/`, {}, { withAuth: true }),

  // Kakao Channels
  getKakaoChannels: () =>
    apiClient.get(`${API_BASE}/channels/`, { withAuth: true }),
    
  syncChannelsFromSendon: () =>
    apiClient.post(`${API_BASE}/channels/sync_from_sendon/`, {}, { withAuth: true }),
    
  updateChannel: (id, data) =>
    apiClient.put(`${API_BASE}/channels/${id}/`, data, { withAuth: true }),
    
  deleteChannel: (id) =>
    apiClient.delete(`${API_BASE}/channels/${id}/`, { withAuth: true }),

  // Alimtalk Templates
  getAlimtalkTemplates: () =>
    apiClient.get(`${API_BASE}/templates/`, { withAuth: true }),
    
  syncTemplatesFromSendon: () =>
    apiClient.post(`${API_BASE}/templates/sync_from_sendon/`, {}, { withAuth: true }),
    
    
  pullFromSendon: () =>
    apiClient.post(`${API_BASE}/templates/pull_from_sendon/`, {}, { withAuth: true }),
    
  createFromExample: (data) =>
    apiClient.post(`${API_BASE}/templates/create_from_example/`, data, { withAuth: true }),

  // Notification Queue
  getQueuedNotifications: (params = {}) =>
    apiClient.get(`${API_BASE}/queue/`, { params, withAuth: true }),

  cancelQueuedNotification: (id) =>
    apiClient.delete(`${API_BASE}/queue/${id}/`, { withAuth: true }),

  retryFailedNotification: (id) =>
    apiClient.post(`${API_BASE}/queue/${id}/retry/`, {}, { withAuth: true }),
};
// 과제 미완수자 명단에서 고른 과제들에 미완료 안내 알림톡을 보낸다.
// 자동 배치가 아니라 교사가 직접 고른 것만 나간다.
export const sendUnfinishedNoticeAPI = (assignmentIdList) =>
  apiClient.post(
    `${API_BASE}/unfinished-notice/`,
    { assignment_id_list: assignmentIdList },
    { withAuth: true }
  );
